import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { LangProvider } from "@/translations";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { ValuesMarquee } from "@/components/site/ValuesMarquee";
import { About } from "@/components/site/About";
import { Expertise } from "@/components/site/Expertise";
import { Journey } from "@/components/site/Journey";
import { Location } from "@/components/site/Location";
import { Contact } from "@/components/site/Contact";
import { Faq } from "@/components/site/Faq";
import { Footer } from "@/components/site/Footer";
import { FloatingWidget } from "@/components/site/FloatingWidget";

function App() {
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <LangProvider>
      <div className="App bg-cream">
        <div className="grain-overlay" />
        <Navbar />
        <main>
          <Hero />
          <ValuesMarquee />
          <About />
          <Expertise />
          <Journey />
          <Location />
          <Contact />
          <Faq />
        </main>
        <Footer />
        <FloatingWidget />
        <Toaster position="top-center" richColors />
      </div>
    </LangProvider>
  );
}

export default App;
